import { useContext } from "react";
import { AppContext } from "@/modules/app/AppProvider";

export const useTenantInfo = () => {
  const { state } = useContext(AppContext);

  return {
    enableAdvancedGuardRails: state.enableAdvancedGuardRails,
    teammatesEnabled: state.teammatesEnabled,
    rbacEnabled: state.rbacEnabled,
    enableKnowledgeEngine: state.enableKnowledgeEngine,
    enableKnowledgeEngineLearningsV2: state.enableKnowledgeEngineLearningsV2,
    enableKnowledgeEngineMultimodal: state.enableKnowledgeEngineMultimodal,
    currency: state.currency,
    // Add other tenant info properties as needed
  };
};
